import Vue from 'vue';
import DCodemirror from './DCodemirror.vue';
import { registerComponents, vueUse, registerComponentProgrammatic } from '../../../utils/plugins';

const components = {
  DCodemirror,
};

const ModalProgrammatic = {
  async load(options) {
    await import('codemirror/lib/codemirror.css');
    await import('codemirror/theme/material.css');

    const module = await import('codemirror/lib/codemirror.js');
    const CodeMirror = module.default;

    const modes = options.modes || [];

    const modeImports = modes.map(mode => import(`codemirror/mode/${mode}/${mode}.js`));

    await Promise.all(modeImports);

    return CodeMirror;
  },
};

const Registered = {
  install(Vue) {
    registerComponents(Vue, components);
    registerComponentProgrammatic(Vue, '$codemirror', ModalProgrammatic);
  },
};

vueUse(Registered);

export default Registered;

export {
  DCodemirror,
  ModalProgrammatic,
};